module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPlJREFUWEftlsERwiAQRXepRDvRSkwagFCBpgICDUQrMZ1II8s6zGhGJnoEPMCNC//zdvbvIlQ+WFkfmoGVgDHmIISYAWCXsyyIuBDRqLVeos5qwDl3Z+ZDTvH329GElPKYGJimaUbEroQBABiVUpfEQLw45zpmzl0CL6W8rjQK/finTGvDRuB/CMQkRMSTECJrG8Z2IKJea+2rBdHXJCwZxQDglVL7hIAxZoeI59wlCCF4Zr5thlGtRPyfLmgEGoGSCwkRLZsktNbGFelcohTMfB2GoU+CyFr7yL0Rf3xum4SvfTASyD2MfAghDqN0LS+B/ptGS8LqBJ5NEGQhmu3RJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_options.png
// module id = vF5L
// module chunks = 96